import React from 'react';
import { motion } from 'framer-motion';
import { Battery, Frown, Flame, Cookie, Calendar } from 'lucide-react';
const painPoints = [{
  icon: Battery,
  text: 'Hay días en los que tienes toda la energía del mundo… y otros en los que no puedes ni levantarte.'
}, {
  icon: Frown,
  text: 'Tus cambios de ánimo te confunden y no entiendes por qué te sientes así.'
}, {
  icon: Flame,
  text: 'Inflamación, cansancio y malestar que aparecen sin razón aparente.'
}, {
  icon: Cookie,
  text: 'Antojos que sabotean tus esfuerzos una y otra vez.'
}, {
  icon: Calendar,
  text: 'Sientes que pierdes el control de tu rutina cada mes.'
}];
export function PainIdentificationSection() {
  return <section className="w-full bg-bg-alt py-16 md:py-24 px-4" data-id="element-65">
      <div className="max-w-5xl mx-auto" data-id="element-66">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="font-serif text-3xl md:text-4xl text-center text-text-primary mb-12" data-id="element-67">
          ¿Te suena familiar?
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-68">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex gap-4 items-start bg-white/50 p-5 rounded-2xl" data-id="element-69">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-secondary flex items-center justify-center" data-id="element-70">
                <point.icon className="w-6 h-6 text-accent" strokeWidth={1.5} data-id="element-71" />
              </div>
              <p className="text-text-primary leading-relaxed" data-id="element-72">{point.text}</p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-center text-lg md:text-xl text-accent font-medium mb-12" data-id="element-73">
          Si te identificas con esto, no estás sola. Y no es tu culpa.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.8
      }} className="relative max-w-3xl mx-auto rounded-3xl overflow-hidden shadow-[0_20px_50px_-12px_rgba(232,140,140,0.25)]" data-id="element-74">
          {/* Overlay para suavizar/difuminar ligeramente los bordes internos */}
          <div className="absolute inset-0 pointer-events-none rounded-3xl shadow-[inset_0_0_20px_rgba(247,239,234,0.8)] z-10" data-id="element-75"></div>

          <video src="https://cdn.magicpatterns.com/uploads/2trPy91ibmiCTxZ5fCPY2E/555.mp4" className="w-full h-auto object-cover" controls autoPlay muted loop playsInline data-id="element-76" />
        </motion.div>
      </div>
    </section>;
}